{
  "upload": {
    "heading": "Add photos",
    "description": "Each photo will correspond to an individual product",
    "choose": "Choose photos",
    "photoSelected": "{{count}} photo selected",
    "photoSelected_plural": "{{count}} photos selected",
    "maxPhotos": "You can select up to {{count}} photo",
    "maxPhotos_plural": "You can select up to {{count}} photos",
    "continue": "Continue",
    "back": "Back",
    "loading-description": "We are loading your photos...",
    "more-purchase-less-price": "The more framed prints you order, the less you spend",
    "how-many-frames": "How many framed prints would you like to add?",
    "description-mobile": "Each photo will correspond to an individual product",
    "title": "Drag and drop your photos here",
    "subheading": "You can select up to 360 photos",
    "title-mobile": "Upload from your smartphone gallery",
    "choose-or-take": "Choose or take photo",
    "computer": "Computer",
    "google-photo": "Google Photo",
    "gallery": "Gallery",
    "my-photos": "Your photos",
    "upload-from": "Upload from",
    "upload-or-drag": "Upload your photos or drag them in this area",
    "other-choises": "Or upload from",
    "long-press-zoom": "Long press on the photos to zoom in",
    "subtitle-mobile": "Or upload from",
    "add": "Add photos",
    "smartphone": "Smartphone",
    "family-friends": "Family and friends",
    "or-other-choises": "Or upload from",
    "upload-error-title": "Unable to upload one or more files",
    "upload-error-description": "The file may be corrupted or in an unsupported format. Please check it and try again.",
    "upload-error-description-list": "The following files might be corrupted or in an unsupported format:",
    "show-error-list": "Show full list",
    "upload-error-description-head": "The following files: ",
    "upload-error-description-tail-counter": " and other {{counter_file}} may be corrupted or in an unsupported format.",
    "upload-error-description-tail": " they may be corrupted or in an unsupported format.",
    "upload-computer-title": "Upload your photos",
    "upload-computer-description": "or drag them into this area",
    "upload-from-other-source": "Or upload them from",
    "upload-from-computer": "Choose your photos",
    "upload-format": "Formats",
    "loading-wait": "Please wait a few moments",
    "loading-login-google": "We're connecting your Google account",
    "qr-code": "Ready to receive photos",
    "upload-qr-title": "Continue on your phone",
    "upload-qr-description": "Scan this code with your smartphone and follow the instructions",
    "upload-qr-loading-title": "Upload from your Smartphone",
    "upload-qr-loading-description": "Please wait a moment, we are generating a QR code",
    "upload-family-title": "Family and friends",
    "upload-family-description": "Copy this link and send it to your family and friends",
    "upload-family-loading-description": "Please wait a moment, we are generating a link",
    "retry": "Upload more photos",
    "upload-gallery-title": "Upload from your smartphone gallery",
    "upload-style": "Design",
    "choose-with-minimum": "Choose at least {{photos}} photos",
    "upload-from-your-source": "While you wait you can upload your photos from",
    "hide-error-list": "Close full list",
    "view-uploaded-photo": "See uploaded photos",
    "title-choose": "Choose your photos",
    "choose-max": "Choose {{photos}} photos",
    "error": {
      "corrupted-files": {
        "title": "Some photos couldn't be uploaded",
        "description": "The following files might be corrupted or in an unsupported format:",
        "cta": "OK, thanks"
      },
      "low-memory": {
        "title": "",
        "description": "",
        "cta": "OK, thanks"
      },
      "network-unavailable": {
        "title": "Photo upload failed",
        "description": "Check your connection and try again. If the issue persists, refresh the page in a few minutes.",
        "cta": "Try again"
      },
      "unknown": {
        "title": "Photo upload failed",
        "description": "Something went wrong and we couldn't load the photos sent to you. Please try again.",
        "cta": "OK, thanks"
      }
    }
  },
  "customize": {
    "other_options": "Other options",
    "add-to-cart": "Add to cart",
    "redo": "Redo",
    "undo": "Undo",
    "add-project-title": "Add a title to the project",
    "add-frame": "Add",
    "delete-frame": "Delete",
    "tutorial": "Tutorial",
    "save": "Save",
    "no-frame": "Start creating",
    "no-frame-description": "Upload your photos or drag them into this area. Each photo will correspond to an individual product.",
    "choose": "Add photos",
    "create-something-else": "Looking for another idea?",
    "create-new-project": "Create a new project",
    "you-want-delete-frame": "Do you want to delete it?",
    "you-want-delete-frame-description": "You won’t be able to recover the project and will need to start again from scratch.",
    "delete": "Delete",
    "abort": "Cancel",
    "other-options": "Other options",
    "default-project-title": "Your product",
    "go-to-site": "Go to site",
    "ignore": "Ignore",
    "suboptimal-quality": "The quality of the photo is not the best",
    "suboptimal-solution": "This can be fixed in different ways:",
    "change-photo": "Replace with a higher quality photo",
    "remove-zoom": "Remove the zoom you applied",
    "change-format": "Select a smaller size",
    "keep-anyway": "Print anyway",
    "continue": "Continue",
    "no-frame-mobile": "Start creating",
    "no-frame-description-mobile": "Each photo will correspond to an individual product.",
    "see-other-products": "See more products",
    "confirm": "Confirm",
    "applyAll": "Apply to all (€{{price}})",
    "open_menu": "Open menu",
    "color-correction": "Ideal for enhancing the colors of your photos, if they have not already been retouched.",
    "change": "Change",
    "add-another-frame": "Add more",
    "no-frame-description-new": "Upload your photos or drag them into this area.",
    "empty-state-title": "Can't see your photos?",
    "empty-state-description": "You'll receive a notification as soon as we've uploaded them, and you'll find them in the section:",
    "empty-state-other-photos": "Or upload more photos",
    "empty-state-cta-second": "Add photos",
    "empty-state-description-mobile": "Uploaded photos will appear here",
    "switch-to-set-3x": "Switch to set of 3 Tiles",
    "switch-to-set-6x": "Switch to set of 6 Tiles",
    "switch-to-set-9x": "Switch to set of 9 Tiles"
  },
  "lookups": {
    "layout": "Layout",
    "glass": "Acrylic glass",
    "format": "Size",
    "frame-color": "Frame colour",
    "passepartout-color": "Mount",
    "passepartout-type": "Photo area",
    "correction": "Colour correction",
    "front-surface": "Acrylic glass",
    "passepartout": "Border",
    "front-surface-description": "Acrylic glass serves as a protective layer, enhancing the radiance of the photo printed onto lustre photographic paper.",
    "passepartout-description": "You can apply a white border around the photo for that extra touch of elegance.",
    "correction-description": "Ideal for enhancing the colours of your photos, if you have not retouched them.",
    "suboptimal": "Not ideal",
    "side-color": "Side colour",
    "side-thickness": "Thickness",
    "border-type": "Edge",
    "border-type-description": "Choose the effect you prefer for the edge of your canvas and place the important details of the photo in the center.",
    "paper": "Finish",
    "format-group-print_classic": "Classic",
    "format-group-print_classic-referencing-poster": "Posters and enlargements",
    "format-group-poster": "Posters and enlargements",
    "format-group-poster-referencing-print_classic": "Classic",
    "format-defaultGroup": "",
    "format-referencingOtherGroup": "",
    "paper_color": "Colour",
    "text": "Text",
    "format-group-print_pro": "Pro Prints",
    "format-group-print_pro-referencing-poster_pro": "Pro Posters and enlargements",
    "format-group-poster_pro": "Pro Posters and enlargements",
    "format-group-poster_pro-referencing-print_pro": "Pro Prints",
    "boxstyle": "Style",
    "printtype": "Paper",
    "kit-type": "Quantity"
  },
  "filters": {
    "blackandwhite": "Black & White",
    "sepia": "Sepia",
    "crossprocess": "Cross Process",
    "route66": "Route 66",
    "vintage70": "Vintage",
    "softportrait": "Soft Portrait",
    "landscape": "Landscape",
    "drama": "Drama",
    "original": "Original",
    "mix": "Mix"
  },
  "edit": {
    "frame": "Frame",
    "filters": "Filters",
    "replace": "Replace photo",
    "redo": "Redo",
    "undo": "Undo",
    "back": "Save and return",
    "save": "Save",
    "edit_photo": "Edit photo",
    "edit-photo": "Edit photo",
    "saving": "Saving",
    "saved": "Changes saved",
    "saving_mobile": "Saving...",
    "saving-mobile": "Saving...",
    "add-photos": "Add photos",
    "restore": "Restore",
    "borders": "Edges",
    "adjustments": "Adjustments",
    "replace-mobile": "Replace",
    "orientation": "Orientation",
    "exit": "Close changes",
    "save-modify": "Save changes",
    "title": "Edit",
    "flip-vertical": "Vertical mirror",
    "flip-horizontal": "Horizontal mirror",
    "saved_mobile": "Saved",
    "photo-next": "Next photo",
    "photo-prev": "Previous photo",
    "photo-item": "Photo {{number}}"
  },
  "modal-exit-project": {
    "title": "Want to leave the project?",
    "description": "Log in or sign up to save your project, otherwise it will be lost.",
    "cancel": "Cancel",
    "exit": "Exit",
    "title-with-logged-user": "Do you want to exit the project?",
    "description-with-logged-user": "Thanks to autosave, you’ll be able to recover your work from the “Your projects” section.",
    "cancel-with-logged-user": "Cancel",
    "exit-with-logged-user": "Save and exit"
  },
  "modal-quality-alert": {
    "suboptimal-quality": "The photo quality\nis not the best",
    "suboptimal-solution": "This can be fixed in different ways:",
    "change-photo": "Replace photo",
    "remove-zoom": "Remove the magnification you applied to the photo",
    "change-format": "Choose another format",
    "close": "Print anyway",
    "change-format-or-photo": "We recommend replacing it with a higher quality photo or selecting a smaller size",
    "change-only-photo": "We recommend replacing it with a higher quality photo",
    "suboptimal-quality-multiplr": "",
    "change-photo-clickable": "Replace photo",
    "remove-zoom-clickable": "Remove the zoom",
    "change-format-clickable": "Select a smaller size",
    "sub-quality-multiple-description": "The photo may appear blurry, but if it's special to you, print it anyway!",
    "continue": "Continue",
    "abort": "Abort",
    "suboptimal-quality-multiple": "The quality of some photos\nis not the best",
    "fix": "Resolve",
    "ignore": "Ignore",
    "quality-check": "Check quality",
    "change-format-less-than": "Select another size smaller than {{format}} cm",
    "delete": "Delete this item",
    "sub-quality-multiple-subdescription": "It’s the memory that counts!",
    "print-anyway": "Print anyway"
  },
  "modal-empty-images": {
    "title": "Photos are missing\nfrom your project",
    "description": "Check the remaining empty spaces\nand upload your photos to continue",
    "check": "Check",
    "title-adhesive": "Some tiles are missing photos",
    "description-adhesive": "Add the missing photos to complete the set. This product is only available in sets of 3, 6 or 9.",
    "check-adhesive": "Complete the set"
  },
  "modal-multiple-purchase": {
    "title": "Create beautiful walls!",
    "description": "Choose your photos based on the number of wall prints you wish to create. The more prints you order, the less you spend!",
    "option-3-5": "Add between 3 and 5 prints",
    "option-6-8": "Add between 6 and 8 prints",
    "option-9-more": "Add 9 prints or more",
    "option-1-2": "Add  1 or 2 prints"
  },
  "general": {
    "frame": "framed print",
    "frames": "framed prints",
    "save": "Save",
    "chat": "Chat",
    "product": "product",
    "products": "products",
    "modal": "modal",
    "editor": "Editor PhotoSì",
    "set-of-frames": "Set of {{count}} Photo Tile",
    "set-of-frames_plural": "Set of {{count}} Photo Tiles",
    "frame-counter": "Frame",
    "frame-counter_plural": "Frames",
    "set-of-frames-counter": "Photo Tile",
    "set-of-frames-counter_plural": "Photo Tiles",
    "photo": "photo",
    "products-counter": "{{count}} product",
    "products-counter_plural": "{{count}} products",
    "drag": "Drop your photos here to add them to the project"
  },
  "modal-upload-to-cart": {
    "title": "We are uploading your photos",
    "description": "Please don't close the page, it will only take a few moments",
    "abort": "Cancel",
    "title-complete": "Upload complete!",
    "description-complete": "Your products are in the cart",
    "eta-minutes-seconds": "Just {{minutes}} and {{seconds}} left",
    "eta-minutes": "Just {{minutes}} left",
    "eta-minutes_plural": "Just {{minutes}} left",
    "eta-seconds": "Almost done, just {{seconds}} left",
    "minutes": "{{count}} minute",
    "minutes_plural": "{{count}} minutes",
    "seconds": "{{count}} seconds",
    "title-mobile": "We’re loading\nyour photos...",
    "description-mobile": "Please don't close the page, it will only take a few moments",
    "description-bad-network": "Your connection is a bit slow, so this might take longer than usual. Please stay on this screen to avoid interrupting the upload.",
    "description-slow-network": "This is taking a bit longer than expected, but we're getting there! Please stay on this screen to avoid interrupting the upload."
  },
  "modal-error-cart": {
    "title": "Photo upload failed",
    "description": "There may be a connection issue. Please check your network and try again.",
    "retry": "Try again",
    "title-mobile": "Photo upload failed",
    "description-mobile": "There may be a connection issue. Please check your network and try again."
  },
  "rotate_to_portrait": {
    "message": "Please rotate your device to portrait mode to continue"
  },
  "modal-save-changes": {
    "title": "Do you want to save your changes?",
    "description": "You have unsaved changes, you’ll lose them if you go back.",
    "save": "Save",
    "saving": "Saving...",
    "discard": "Ignore"
  },
  "modal-apply-all": {
    "title": "Apply to all items?",
    "abort": "Cancel",
    "confirm": "Confirm"
  },
  "loading": {
    "0": "",
    "1": "Please wait...",
    "2": "The upload is taking a bit longer than expected, sorry for the wait..."
  },
  "toast": {
    "fix": "Resolve",
    "suboptimal-quality": "Quality of the photo is not the best",
    "uploading-photo-error": "Error uploading the photo",
    "uploading-photos-error": "Error uploading the photos",
    "frame-deleted-successfully": "Your frame has been successfully deleted",
    "invalid-photo-format": "The selected format is not supported",
    "invalid-of-some-photos-format": "The selected format for some photos is not supported",
    "valid-photo-format-reminder": "Please remember to select only files in PNG, JPG, JPEG, or HEIC format",
    "incognito-hint": "In incognito mode, some editor features may not be available.",
    "accept-and-close": "Close",
    "product-deleted-successfully": "Product successfully deleted",
    "check": "Check",
    "cuts-check-hint": "Some photos have been cropped, please review the framing",
    "product-option-applied-successfully": "The option {{option}} has been successfully applied",
    "products-deleted-successfully": "Products successfully deleted",
    "loading": "Loading....",
    "min-product-missing": "This product requires a minimum of {{min_value}} photos.",
    "add-missing": "Add",
    "accept": "I understand",
    "project-not-uploaded": "Some photos failed to load and have been removed. Please try again.",
    "min-product-missing_happy_case_classic": "This box requires a minimum of {{min_value}} photos.",
    "min-product-missing_happy_case_vintage": "This box requires a minimum of {{min_value}} photos.",
    "min-product-missing_fotokit_homedecor": "This Photo Kit requires a minimum of {{min_value}} photos.",
    "min-product-missing_fotokit_miniscrap": "This Photo Kit requires a minimum of {{min_value}} photos.",
    "complete-missing_happy_case_classic": "This box is complete! You can add it to your cart whenever you're set.",
    "complete-missing_happy_case_vintage": "This box is complete! You can add it to your cart whenever you're set.",
    "complete-missing_fotokit_homedecor": "This PhotoKit is complete! You can add it to your cart whenever you're set.",
    "complete-missing_fotokit_miniscrap": "This PhotoKit is complete! You can add it to your cart whenever you're set.",
    "created_newbox_happy_case_classic": "This box is complete! We've added the extra photos to a new box.",
    "created_newbox_happy_case_vintage": "This box is complete! We've added the extra photos to a new box.",
    "created_newbox_fotokit_homedecor": "This PhotoKit is complete! We've added the extra photos to a new PhotoKit.",
    "created_newbox_fotokit_miniscrap": "This PhotoKit is complete! We've added the extra photos to a new PhotoKit.",
    "show": "Check it out",
    "photos-added": "Photos added to the \"Your photos\" section",
    "products-added": "{{count}} photo added successfully",
    "products-added_plural": "{{count}} photos added successfully",
    "duplicate": "Product successfully duplicated",
    "duplicate_plural": "Products successfully duplicated",
    "products-removed": "Photo deleted successfully",
    "products-removed_plural": "{{count}} photos deleted successfully",
    "products-restored": "Photo restored successfully",
    "products-restored_plural": "{{count}} photos restored successfully",
    "product-option-updated": "Option {{option}} updated",
    "product-replaced": "Photo successfully replaced"
  },
  "modal-picker-google-photo": {
    "title-upload": "Upload from Google Photos",
    "description-upload": "Sign in and choose your favourite photos",
    "title-logged": "Your account is now linked to Google Photos!",
    "description-logged": "To protect your privacy, Google only allows PhotoSì to access the photos you choose.",
    "choose-photo": "Choose photos",
    "login": "Connect to Google Photos",
    "logged-with": "Logged as",
    "logout": "Log out",
    "errors": {
      "no-access": "We can't access your photos.\nTo grant permission, please log out and log back in to Google Photos."
    }
  },
  "chat": {
    "initialMessage": "Hi! I'm Sara, PhotoSì's AI-powered virtual assistant. If you're looking for a gift, a product, or just need a hand, I'm here to help!",
    "title": "PhotoSì",
    "subtitle": "",
    "footer": "",
    "inputPlaceholder": "Write your question here..."
  },
  "borders": {
    "mirrored": "Mirrored",
    "extended": "Stretched",
    "folded": "Wrap-around"
  },
  "canvas": {
    "border-text-top": "Upper edge",
    "border-text-right": "Right edge",
    "border-text-bottom": "Bottom edge",
    "border-text-left": "Left edge"
  },
  "adjustments": {
    "brightness": "Brightness",
    "contrast": "Contrast",
    "saturation": "Saturation",
    "restore": "Restore",
    "close": "Done"
  },
  "lookups-options": {
    "Folded": "Wrap-around",
    "Mirrored": "Mirrored",
    "Extended": "Stretched",
    "homedecor": {
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Black",
      "frame-color-WHITE": "White",
      "frame-color-WOOD": "Wood",
      "frame-color-SILVER": "Silver",
      "frame-color-GOLD": "Gold",
      "frame-color-BRONZE": "Bronze",
      "passepartout-color-WHITE": "White",
      "passepartout-color-BLACK": "Black",
      "passepartout-type-PHYSICAL_STANDARD": "Classic",
      "passepartout-type-PHYSICAL_DECENTERED": "Off-centre",
      "correction-YES": "Yes",
      "correction-NO": "No",
      "passepartout-NO": "without border",
      "passepartout-YES": "with border",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "full photo",
      "front-surface-NO": "No",
      "front-surface-YES": "Yes",
      "side-color-WHITE": "White",
      "side-color-BLACK": "Black",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3.5 cm",
      "border-type-Folded": "Wrap-around",
      "border-type-Mirrored": "Mirrored",
      "border-type-Extended": "Stretched",
      "kit-type-3x": "Set of 3 pieces",
      "kit-type-6x": "Set of 6 pieces",
      "kit-type-9x": "Set 9 pieces",
      "kit-type-3x_selected-lookup": "Set of 3 pcs",
      "kit-type-6x_selected-lookup": "Set of 6 pcs",
      "kit-type-9x_selected-lookup": "Set of 9 pcs"
    },
    "print": {
      "format-7x10": "7x10 cm",
      "format-10x10": "10x10 cm",
      "format-10x13": "10x13 cm",
      "format-10x15": "10x15 cm",
      "format-10x_PANORAMIC": "10 cm variable",
      "format-12x16": "12x16 cm",
      "format-12x_PANORAMIC": "12 cm variable",
      "format-13x13": "13x13 cm",
      "format-13x17.33": "13x17 cm",
      "format-13x19.5": "13x19 cm",
      "format-13x_PANORAMIC": "13 cm variable",
      "format-15x22": "15x22 cm",
      "format-20x27": "20x27 cm",
      "format-30x45": "30x45 cm",
      "format-40x50": "40x50 cm",
      "format-50x75": "50x75 cm",
      "format-24x32": "24x32 cm",
      "format-32x24": "32x24 cm",
      "format-30x40": "30x40 cm",
      "format-40x30": "40x30 cm",
      "format-40x60": "40x60 cm",
      "format-60x40": "60x40 cm",
      "format-50x70": "50x70 cm",
      "format-70x50": "70x50 cm",
      "format-16x16": "16x16 cm",
      "format-18x24": "18x24 cm",
      "format-24x18": "24x18 cm",
      "format-24x24": "24x24 cm",
      "format-30x30": "30x30 cm",
      "format-40x40": "40x40 cm",
      "format-50x50": "50x50 cm",
      "format-50x60": "50x60 cm",
      "format-70x70": "70x70 cm",
      "format-70x100": "70x100 cm",
      "format-100x70": "100x70 cm",
      "format-20x20": "20x20 cm",
      "format-20x30": "20x30 cm",
      "format-30x20": "30x20 cm",
      "format-12x12": "12x12 cm",
      "format-12x18": "12x18 cm",
      "format-18x12": "18x12 cm",
      "format-15x15": "15x15 cm",
      "format-15x20": "15x20 cm",
      "format-20x15": "20x15 cm",
      "format-17x17": "17x17 cm",
      "format-50x100": "50x100 cm",
      "format-100x50": "100x50 cm",
      "format-60x90": "60x90 cm",
      "format-90x60": "90x60 cm",
      "format-90x90": "90x90 cm",
      "format-90x120": "90x120 cm",
      "format-120x90": "120x90 cm",
      "format-120x120": "120x120 cm",
      "format-13x18": "13x18 cm",
      "format-18x13": "18x13 cm",
      "format-60x60": "60x60 cm",
      "format-100x100": "100x100 cm",
      "frame-color-BLACK": "Black",
      "frame-color-WHITE": "White",
      "frame-color-WOOD": "Wood",
      "frame-color-SILVER": "Silver",
      "frame-color-GOLD": "Gold",
      "frame-color-BRONZE": "Bronze",
      "passepartout-color-WHITE": "White",
      "passepartout-color-BLACK": "Black",
      "passepartout-type-PHYSICAL_STANDARD": "Classic",
      "passepartout-type-PHYSICAL_DECENTERED": "Off-centre",
      "correction-YES": "Yes",
      "correction-YES-description": "Ideal for enhancing the colours of your photos, if you have not retouched them.",
      "correction-NO": "No",
      "correction-NO-description": "",
      "passepartout-NO": "No",
      "passepartout-YES": "Yes",
      "layout-1x": "1x",
      "layout-4x": "4x",
      "layout-6x": "6x",
      "layout-9x": "9x",
      "layout-1x_FULL_PHOTO": "full photo",
      "front-surface-NO": "No",
      "front-surface-YES": "Yes",
      "side-color-WHITE": "White",
      "side-color-BLACK": "Black",
      "side-thickness-2_CM": "2 cm",
      "side-thickness-4_CM": "3.5 cm",
      "border-type-Folded": "Wrap-around",
      "border-type-Mirrored": "Mirrored",
      "border-type-Extended": "Stretched",
      "paper-GLOSSY": "Glossy",
      "paper-GLOSSY-description": "A burst of light for your most vibrant photos",
      "paper-MATTE": "Lustre",
      "paper-MATTE-description": "A velvety, elegant finish with no glare",
      "format-15x22.5": "15x22 cm",
      "format-variable": " cm",
      "format-8x10": "8x10 cm",
      "format-12x15": "12x15 cm",
      "format-20x25": "20x25 cm",
      "format-10x00": "10 cm variable",
      "format-12x00": "12 cm variable",
      "format-13x00": "13 cm variable",
      "format-13x19": "13x19 cm",
      "format-24x30": "24x30 cm",
      "format-24x36": "24x36 cm",
      "format-30x60": "30x60 cm",
      "format-35x35": "35x35 cm",
      "format-35x50": "35x50 cm",
      "format-60x80": "60x80 cm",
      "boxstyle-JUNGLE": "Jungle",
      "boxstyle-LOVE_IS": "Love is",
      "boxstyle-BLOOM": "Bloom",
      "boxstyle-OCEAN": "Ocean",
      "boxstyle-MOON": "Moon",
      "boxstyle-SUNSHINE": "Sunshine",
      "boxstyle-LIFE": "Life",
      "boxstyle-JUNGLE-description": "",
      "boxstyle-LOVE_IS-description": "",
      "boxstyle-BLOOM-description": "",
      "boxstyle-OCEAN-description": "",
      "boxstyle-MOON-description": "",
      "boxstyle-SUNSHINE-description": "",
      "boxstyle-LIFE-description": "",
      "boxstyle-CHRISTMAS": "Magic Christmas",
      "boxstyle-FLOWER": "Flower",
      "boxstyle-GAME": "Game",
      "boxstyle-GREEN": "Green",
      "boxstyle-WONDER": "Wonder",
      "boxstyle-CHRISTMAS-description": "",
      "boxstyle-FLOWER-description": "",
      "boxstyle-GAME-description": "",
      "boxstyle-GREEN-description": "",
      "boxstyle-WONDER-description": "",
      "format-10x13.33": "10x13 cm",
      "printtype-PHOTOGRAPHIC": "Fujifilm photo paper",
      "printtype-PHOTOGRAPHIC-active-label": "Fujifilm",
      "printtype-PHOTOGRAPHIC-description": "• For traditional paper lovers\n• Ideal for professional photos",
      "printtype-INKJET": "PhotoSì photo paper",
      "printtype-INKJET-active-label": "PhotoSì",
      "printtype-INKJET-description": "• Excellent colour reproduction\n• Eco-friendly choice",
      "boxstyle-LOVE_IS_SPECIAL": "Love you",
      "boxstyle-LOVE_IS_SPECIAL-description": ""
    },
    "kit-type": {
      "3x": "3 piece set",
      "6x": "6 piece set",
      "9x": "9 piece set"
    }
  },
  "modal-privacy-policy": {
    "privacy-policy-info": "Privacy Policy",
    "editor-privacy-policy-info": "Use of the editor",
    "main-content": "When using our photo editor, we use OPFS (Origin Private File System) browser technology. This technology allows us to quickly and securely handle the files you want to edit, directly from your device.",
    "paragraph-1-title": "What does this mean for you?",
    "paragraph-1-content-1": "Your work remains private and secure, within your browser.",
    "paragraph-1-content-2": "Your files are NOT sent to our servers while your project is being processed.",
    "paragraph-2-title": "How do we protect your privacy?",
    "paragraph-2-content-1": "No data is shared with or tracked by the OPFS.",
    "paragraph-2-content-2": "We don’t have access to files saved locally.",
    "paragraph-2-content-3": "Data can only be accessed by you, on your browser and your device.",
    "know-more-1": "Want to know more? Check out our",
    "privacy-policy": "Privacy Policy",
    "know-more-2": "for full details on how we process your data and your rights.",
    "thanks": "Thank you for your trust and have fun creating with our editor!"
  },
  "header": {
    "photo": "Your photos",
    "save": "Save",
    "saved": "Saved!",
    "total": "Total",
    "products": "products",
    "go-to-cart": "Add to cart",
    "confirm": "Confirm",
    "product": "product",
    "product_plural": "products",
    "articles": "articles:",
    "add-project-title": "Add project title",
    "save-project-title": "Save project title",
    "edit-project-title": "Edit project tile",
    "save-project": "Save the project",
    "saving-project": "Saving in progress",
    "project-saved": "Project saved",
    "uploading": "Uploading photos",
    "photo-notification": "Your photos — new images available"
  },
  "discounts-tooltip": {
    "prints-classic": "Classic Prints",
    "prints-vintage": "Vintage Prints",
    "prints-pro": "Pro Classic Prints",
    "n-units-size": "{{quantity}} units ({{format}})",
    "print_classic": "Classic Prints",
    "poster": "Posters and enlargements",
    "print_vintage": "Vintage Prints",
    "happy_case_classic": "Classic Happy Case",
    "happy_case_vintage": "Vintage Happy Case",
    "fotokit_homedecor": "Home Decor PhotoKit",
    "fotokit_miniscrap": "Mini Scrap PhotoKit",
    "print_classic_with_border": "Bordered Prints"
  },
  "discounts-table": {
    "prints-title": "The more you print, the less you spend!",
    "prints-description": "Here's how to get quantity discounts on prints",
    "prints-from-to": "from {{from}} to {{to}} photos",
    "prints-from-more": "from {{from}} or more",
    "price-discount": "from €{{price}}",
    "unit-discount": "each",
    "prints-to-reach": "Add {{photos}} more photos for {{discount}}% off",
    "greetings": "Congratulations!",
    "photo": "{{photos}} photos",
    "prints-subtitle": "Here's how to get quantity discounts on prints",
    "discover-discount": "Discover",
    "prints-to-reach-head": "Add ",
    "prints-to-reach-middle": "{{count}} more photo",
    "prints-to-reach-middle_plural": "{{count}} more photos",
    "prints-to-reach-tail": " for {{discount}} off",
    "prints-description-mobile": "Discounts for the chosen size: {{format}}"
  },
  "modal-suggested-format": {
    "title": "Suggested size",
    "option-1": "10x10 cm",
    "description-1": "Square",
    "option-2": "10x13 cm",
    "description-2": "Perfect for avoiding cropping your photos",
    "option-3": "10x15 cm",
    "description-3": "Standard for Albums with sleeves",
    "option-4": "10 cm variable",
    "description-4": "Keeps original proportions. Each photo can have different sizes.",
    "continue": "Continue",
    "suggested": "Recommended"
  },
  "actions": {
    "add_x": "Add {{x}}",
    "remove_x": "Remove {{x}}",
    "edit_x": "Edit {{x}}",
    "close_x": "Close {{x}}",
    "open_x": "Open {{x}}",
    "rotate_left": "Rotate to the left",
    "rotate_right": "Rotate to the right",
    "increase_zoom": "Zoom +",
    "reduce_zoom": "Zoom -",
    "drag_or_edit": "Drag or Edit",
    "slide_right": "Drag right",
    "slide_left": "Drag left",
    "select_x": "Select {{x}}",
    "edit": "Edit",
    "duplicate": "Duplicate",
    "save_and_return": "Save and return",
    "action-list": "Actions",
    "delete": "Delete",
    "replica": "Copies",
    "add_border": "Add a border",
    "zoom": "Preview",
    "options": "Options",
    "select": "Select",
    "quality": "Poor quality",
    "increase": "Add",
    "decrease": "Decrease",
    "format": "Format",
    "finishing": "Finishing",
    "quantity": "Quantity",
    "save": "Save changes",
    "quit_without_save": "Exit without saving",
    "resolve-quality": "Fix quality",
    "sub-quality": "Not ideal quality",
    "paper": "Paper finish",
    "change-format": "Change size",
    "print-options": "View print options",
    "choose-format": "Choose size",
    "save_and_close": "Save and close",
    "close": "Close",
    "select_photo": "Select photo number {{number}}, {{count}} copy",
    "select_photo_plural": "Select photo number {{number}}, {{count}} copies",
    "deselect_photo": "Deselect photo number {{number}}, {{count}} copy",
    "deselect_photo_plural": "Deselect photo number {{number}}, {{count}} copies"
  },
  "photo-drawer": {
    "my-photos": "Your photos",
    "your-photos": "Your photos",
    "order-by": "Sort by",
    "upload": "Upload photos",
    "upload-more": "Upload more photos",
    "upload-from-gallery": "Upload from gallery",
    "add-n-photos": "Add {{number}} photos to the project",
    "select-to-add": "Select photos to add them",
    "shot-date": "Shot date",
    "upload-date": "Upload date",
    "adding": "Adding...",
    "photos-added-to-project": "Photos added to project!",
    "select-photo": "Select photo",
    "name": "File name",
    "shot-date-most-recent": "Capture date: newest first",
    "shot-date-less-recent": "Capture date: oldest first",
    "upload-date-most-recent": "Upload date: newest first",
    "upload-date-less-recent": "Upload date: oldest first",
    "name-alphabetic": "File name: A-Z",
    "name-alphabetic-reverse": "File name: Z-A",
    "upload-from": "Upload from",
    "waiting-upload": "Please wait for the photos to load...",
    "empty-text": "Here you'll find your photos \nonce uploaded",
    "add-photos": "Add photos to the project"
  },
  "modal-picker-my-photos": {
    "title": "Your photos",
    "deselect-all": "Deselect all",
    "confirm": "Confirm",
    "more-print-less-price": "The more you print, the less you spend!",
    "add-n-photos-to-x-discount": "With {{n}} prints you reach {{x}}% discount",
    "select-all": "Select all",
    "progress": "Uploading the photos...",
    "completed": "Completed",
    "delete-selected": "Delete",
    "loading": "Loading...",
    "waiting": "Please wait a few moments...",
    "continue": "Continue",
    "black": "Black frame",
    "white": "White frame",
    "3x": "Set of 3 Photo Tiles",
    "6x": "Set of 6 Photo Tiles",
    "9x": "Set of 9 Photo Tiles",
    "3x_mobile": "3 Photo Tiles",
    "6x_mobile": "6 Photo Tiles",
    "9x_mobile": "9 Photo Tiles",
    "options-title": "Choose your set",
    "options-title-mobile": "Colour and quantity",
    "options-header-title-mobile": "Photo Tile Set"
  },
  "add-other-products": {
    "add-other-products": "Want to add anything?",
    "prints-classic": "Classic prints",
    "prints-vintage": "Vintage prints",
    "prints-pro": "Pro Classic Prints",
    "frame": "Framed Prints",
    "frame-pro": "Pro Framed Prints",
    "add": "Add",
    "from-x": "from {{price}}"
  },
  "tooltip-save-project": {
    "title": "Title",
    "auto-saved": "Project saved automatically!",
    "last-save_date_hour": "Last saving: {{date}} at {{hour}}",
    "saving": "We are saving...",
    "placeholder": "Project 1",
    "edit-auto-saved": "Saved! Every change is saved automatically"
  },
  "authentication": {
    "landing-title": "Log in or register",
    "landing-subtitle": "To save a project, you must log in to your account or register.",
    "login-title": "Great to see you again!",
    "login-subtitle": "",
    "check-email-title": "Enter your email",
    "check-email-subtitle": "",
    "forgot-password-title": "You’ve got mail!",
    "forgot-password-subtitle": "We've sent you an email to create a new password. If you can't find it, we suggest you also check your spam folder.",
    "signup-title": "Create your account",
    "signup-subtitle": "",
    "signup-completed-title": "Your account has been successfully created!",
    "signup-completed-subtitle": "",
    "signup-completed-cta-label": "Close",
    "manage-consents-title": "Manage consent",
    "manage-consents-subtitle": "",
    "vat-user-signup-completed-title": "Your account has been successfully created!",
    "vat-user-signup-completed-subtitle": "You can enter your VAT details later in the profile section and get a 40% discount.",
    "vat-user-signup-completed-cta-label": "Fill in later",
    "login-page-landing-title": "Log in or register",
    "login-page-landing-subtitle": "To continue working on your project, you must log in to your account or register."
  },
  "action-bar": {
    "all": "All",
    "cut": "Cropped"
  },
  "colors": {
    "black": "Black",
    "white": "White",
    "grey": "Grey",
    "greige": "Greige",
    "hazelnut": "Hazelnut",
    "beige": "Beige",
    "yellow": "Yellow",
    "cream": "Cream",
    "vanilla": "Vanilla",
    "peach": "Peach",
    "ivory": "Ivory",
    "pink": "Pink",
    "candy": "Candy",
    "peony": "Peony",
    "fuchsia": "Fuchsia",
    "red": "Red",
    "lavender": "Lavender",
    "lilac": "Lilac",
    "ice": "Sky",
    "sky": "Ice",
    "indigo": "Indigo",
    "blue": "Blue",
    "lake": "Lake",
    "mint": "Mint",
    "green": "Green"
  },
  "modal-configuration-steps": {
    "band-title": "Choose the size",
    "format-title": "Choose the size",
    "avoid-cuts": "How to avoid photo cropping",
    "continue": "Continue",
    "formats-content": {
      "10x13": "Default smartphone format",
      "13x19.5": "Standard for frames and photo albums",
      "8x10": "Small format, big emotions to cherish.",
      "15x22.5": "Standard for frames and photo albums",
      "20x27": "",
      "13x13": "Square",
      "20x30": "",
      "40x50": "",
      "50x50": "",
      "12x15": "The perfect size to bring those special moments back to life.",
      "15x15": "Square",
      "20x25": "A memory that takes up space and lights up the room.",
      "13x17.33": "Default smartphone format",
      "12x18": "Standard for frames and photo albums",
      "40x40": "",
      "40x60": "",
      "15x20": "Default smartphone format",
      "50x70": "",
      "50x60": "",
      "12x12": "Square",
      "50x75": "",
      "10x10": "Square",
      "7x10": "Standard for frames and photo albums",
      "30x45": "",
      "10x15": "Standard for frames and photo albums",
      "12x16": "Default smartphone format",
      "30x40": "",
      "20x20": "",
      "8x_PANORAMIC": "Keeps the original proportions of the shot",
      "12x_PANORAMIC": "Keeps the original proportions of the shot",
      "30x_PANORAMIC": "Keeps the original proportions of the shot",
      "20x_PANORAMIC": "Keeps the original proportions of the shot",
      "13x_PANORAMIC": "Keeps the original proportions of the shot",
      "7x_PANORAMIC": "Keeps the original proportions of the shot",
      "10x_PANORAMIC": "Keeps the original proportions of the shot",
      "40x_PANORAMIC": "Keeps the original proportions of the shot",
      "15x_PANORAMIC": "Keeps the original proportions of the shot",
      "50x_PANORAMIC": "Keeps the original proportions of the shot",
      "suggested": "Perfect for avoiding cropping your photos",
      "13x19": "Standard for frames and photo albums",
      "15x22": "Standard for frames and photo albums",
      "13x17": "Default smartphone format",
      "10x00": "Keeps the original proportions of the shot",
      "8x00": "Keeps the original proportions of the shot",
      "12x00": "Keeps the original proportions of the shot",
      "30x00": "Keeps the original proportions of the shot",
      "20x00": "Keeps the original proportions of the shot",
      "13x00": "Keeps the original proportions of the shot",
      "7x00": "Keeps the original proportions of the shot",
      "40x00": "Keeps the original proportions of the shot",
      "15x00": "Keeps the original proportions of the shot",
      "50x00": "Keeps the original proportions of the shot",
      "18x24": "",
      "24x24": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "35x35": "",
      "35x50": "",
      "30x60": "",
      "60x80": "",
      "70x100": "",
      "print_classic": {
        "7x00": "Keeps the original proportions of the shot",
        "7x_PANORAMIC": "Keeps the original proportions of the shot",
        "10x10": "Square format",
        "10x13": "Default smartphone format",
        "10x15": "Standard size for frames and photo albums",
        "10x_PANORAMIC": "Keeps the original proportions of the shot",
        "10x00": "Keeps the original proportions of the shot",
        "12x12": "Square format",
        "12x16": "Default smartphone format",
        "12x18": "Standard size for frames and photo albums",
        "12x00": "Keeps the original proportions of the shot",
        "12x_PANORAMIC": "Keeps the original proportions of the shot",
        "13x13": "Square format",
        "13x17": "Default smartphone format",
        "13x17.33": "Default smartphone format",
        "13x19": "Standard size for frames and photo albums",
        "13x19.5": "Standard size for frames and photo albums",
        "13x_PANORAMIC": "Keeps the original proportions of the shot",
        "13x00": "Keeps the original proportions of the shot",
        "15x15": "Square format",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Keeps the original proportions of the shot",
        "15x00": "Keeps the original proportions of the shot",
        "7x10": "A mini print, perfect for greeting cards"
      },
      "poster": {
        "20x20": "",
        "20x27": "",
        "20x30": "",
        "30x40": "",
        "30x45": "",
        "40x40": "",
        "40x50": "",
        "40x60": "",
        "50x50": "",
        "50x70": "",
        "50x75": "",
        "50x60": ""
      },
      "print_vintage": {
        "8x10": "Small format, big emotions to cherish.",
        "12x15": "The perfect size to bring those special moments back to life.",
        "20x25": "A memory that takes up space and lights up the room."
      },
      "print_pro": {
        "10x13": "Default smartphone format",
        "10x15": "Standard size for frames and photo albums",
        "12x16": "Default smartphone format",
        "12x18": "Standard size for frames and photo albums",
        "13x17.33": "Default smartphone format",
        "13x17": "Default smartphone format",
        "13x19": "Standard size for frames and photo albums",
        "13x19.5": "Standard size for frames and photo albums",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "7x10": "A mini print, perfect for greeting cards"
      },
      "poster_pro": {
        "20x20": "",
        "18x24": "",
        "20x25": "",
        "24x24": "",
        "20x30": "",
        "24x30": "",
        "24x36": "",
        "30x30": "",
        "30x45": "",
        "30x40": "",
        "35x35": "",
        "40x40": "",
        "35x50": "",
        "30x60": "",
        "40x50": "",
        "50x50": "",
        "40x60": "",
        "50x70": "",
        "50x60": "",
        "50x75": "",
        "60x80": "",
        "70x100": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "fotokit_homedecor": {
        "one": "",
        "other": ""
      },
      "fotokit_miniscrap": {
        "one": "",
        "other": ""
      },
      "print_classic_with_border": {
        "7x00": "Keeps the original proportions of the shot",
        "7x_PANORAMIC": "Keeps the original proportions of the shot",
        "10x10": "Square format",
        "10x13": "Default smartphone format",
        "10x15": "Standard size for frames and photo albums",
        "10x_PANORAMIC": "Keeps the original proportions of the shot",
        "10x00": "Keeps the original proportions of the shot",
        "12x12": "Square format",
        "12x16": "Default smartphone format",
        "12x18": "Standard size for frames and photo albums",
        "12x00": "Keeps the original proportions of the shot",
        "12x_PANORAMIC": "Keeps the original proportions of the shot",
        "13x13": "Square format",
        "13x17": "Default smartphone format",
        "13x17.33": "Default smartphone format",
        "13x19": "Standard size for frames and photo albums",
        "13x19.5": "Standard size for frames and photo albums",
        "13x_PANORAMIC": "Keeps the original proportions of the shot",
        "13x00": "Keeps the original proportions of the shot",
        "15x15": "Square format",
        "15x20": " ",
        "15x22.5": " ",
        "15x22": " ",
        "15x_PANORAMIC": "Keeps the original proportions of the shot",
        "15x00": "Keeps the original proportions of the shot",
        "7x10": "A mini print, perfect for greeting cards"
      }
    },
    "format": {
      "10x13": "10x13 cm",
      "13x19.5": "13x19 cm",
      "8x10": "8x10 cm",
      "15x22.5": "15x22 cm",
      "20x27": "20x27 cm",
      "13x13": "13x13 cm",
      "20x30": "20x30 cm",
      "40x50": "40x50 cm",
      "50x50": "50x50 cm",
      "12x15": "12x15 cm",
      "15x15": "15x15 cm",
      "20x25": "20x25 cm",
      "13x17.33": "13x17 cm",
      "12x18": "12x18 cm",
      "40x40": "40x40 cm",
      "40x60": "40x60 cm",
      "15x20": "15x20 cm",
      "50x70": "50x70 cm",
      "50x60": "50x60 cm",
      "12x12": "12x12 cm",
      "50x75": "50x75 cm",
      "10x10": "10x10 cm",
      "7x10": "7x10 cm",
      "30x45": "30x45 cm",
      "10x15": "10x15 cm",
      "12x16": "12x16 cm",
      "30x40": "30x40 cm",
      "20x20": "20x20 cm",
      "8x_PANORAMIC": "8 cm variable",
      "12x_PANORAMIC": "12 cm variable",
      "30x_PANORAMIC": "30 cm variable",
      "20x_PANORAMIC": "20 cm variable",
      "13x_PANORAMIC": "13 cm variable",
      "7x_PANORAMIC": "7 cm variable",
      "10x_PANORAMIC": "10 cm variable",
      "40x_PANORAMIC": "40 cm variable",
      "15x_PANORAMIC": "15 cm variable",
      "50x_PANORAMIC": "50 cm variable",
      "13x19": "13x19 cm",
      "15x22": "15x22 cm",
      "13x17": "13x17 cm",
      "8x00": "8 cm variable",
      "12x00": "12 cm variable",
      "30x00": "30 cm variable",
      "20x00": "20 cm variable",
      "13x00": "13 cm variable",
      "7x00": "7 cm variable",
      "10x00": "10 cm variable",
      "40x00": "40 cm variable",
      "15x00": "15 cm variable",
      "50x00": "50 cm variable",
      "18x24": "18x24 cm",
      "24x24": "24x24 cm",
      "24x30": "24x30 cm",
      "24x36": "24x36 cm",
      "30x30": "30x30 cm",
      "35x35": "35x35 cm",
      "35x50": "35x50 cm",
      "30x60": "30x60 cm",
      "60x80": "60x80 cm",
      "70x100": "70x100 cm"
    },
    "band": {
      "7": "7 cm",
      "10": "10 cm",
      "12": "12 cm",
      "13": "13 cm",
      "15": "15 cm"
    },
    "bands-content": {
      "available-formats": "Available sizes"
    },
    "avoid-cuts-description": "The recommended size best suits the photos you have selected to avoid unwanted cropping.\n\nIf you prefer another size, your photos will be cropped, but you can still adjust the framing in the next steps.",
    "best-seller": "Best seller",
    "suggested": "Recommended",
    "bands-price": {
      "7": "from €0.49",
      "10": "from €0.59",
      "12": "from €0.79",
      "13": "from €0.99",
      "15": "from €1.99",
      "print_classic": {
        "7": "from €0.29",
        "10": "from €0.35",
        "12": "from €0.42",
        "13": "from €0.48",
        "15": "from €0.99",
        "20": "from €1.99",
        "30": "from €8.90"
      },
      "poster": {
        "one": "",
        "other": ""
      },
      "print_vintage": {
        "one": "",
        "other": ""
      },
      "print_pro": {
        "7": "from €0.49",
        "10": "from €0.59",
        "12": "from €0.79",
        "13": "from €0.99",
        "15": "from €1.99"
      },
      "poster_pro": {
        "one": "",
        "other": ""
      },
      "happy_case_classic": {
        "one": "",
        "other": ""
      },
      "happy_case_vintage": {
        "one": "",
        "other": ""
      },
      "photo_kit": {
        "one": "",
        "other": ""
      }
    },
    "box-style-title": "Choose your design",
    "box-style": {
      "bloom": "Bloom",
      "christmas": "Magic Christmas",
      "love_is": "Love is",
      "moon": "Moon",
      "ocean": "Ocean",
      "sunshine": "Sunshine",
      "flower": "Flower",
      "game": "Game",
      "green": "Green",
      "life": "Life",
      "wonder": "Wonder",
      "jungle": "Jungle",
      "love_is_special": "Love you"
    },
    "box-style-price": "from {{price}}",
    "continue-with": "Continue with the {{format}}",
    "format-change": "You can change it later",
    "format-adapt": "Variable formats maintain the original aspect ratio.\nEach photo can have a different size",
    "papertype-title": "Choose your paper",
    "papertype": {
      "photographic": "Fujifilm Photo Paper",
      "inkjet": "PhotoSì Photo Paper"
    },
    "papertype-content": {
      "photographic": "• For traditional paper lovers\n• Ideal for professional photos",
      "inkjet": "• Excellent colour reproduction\n• Eco-friendly choice"
    },
    "printtype": {
      "photographic": "Fujifilm Photo Paper",
      "inkjet": "PhotoSì Photo Paper"
    },
    "printtype-content": {
      "photographic": "• For traditional paper lovers\n• Ideal for professional photos",
      "inkjet": "• Excellent colour reproduction\n• Eco-friendly choice"
    },
    "paperfinish-title": "Choose your finish",
    "paperfinish": {
      "glossy": "Glossy",
      "matte": "Lustre"
    },
    "paperfinish-content": {
      "glossy": "A burst of light for your most vibrant photos",
      "matte": "A velvety, elegant finish with no glare"
    },
    "paper": {
      "glossy": "Glossy",
      "matte": "Lustre"
    },
    "paper-content": {
      "glossy": "A burst of light for your most vibrant photos",
      "matte": "A velvety, elegant finish with no glare"
    },
    "suggested-lookup": "Recommended",
    "option-prev": "Previous option",
    "option-next": "Next option"
  },
  "group-header": {
    "add-product": "Add a product",
    "add": "Add",
    "add-title": "What do you want to add?",
    "add-new-product": "Add another product",
    "other-product": "Other products",
    "other-photo": "More photos",
    "add-product-2": "Add product",
    "add-new-product-disabled": "Uploading photos",
    "add-more-products": "Add more products",
    "add-more-photos": "Add more photos"
  },
  "group-action-bar": {
    "select": "Select",
    "deselect": "Deselect",
    "selected": "{{count}} selected",
    "selected_plural": "{{count}} selected",
    "grid": "View",
    "delete-selected": "Delete selection"
  },
  "groups": {
    "print_classic-title": "Classic Prints",
    "poster-title": "Posters and enlargements",
    "print_classic-description": "from €0.19 each",
    "poster-description": "from €3.99 each",
    "print_vintage-title": "Vintage Prints",
    "print_vintage-description": "from €0.35 each",
    "print_pro-title": "Pro Prints",
    "poster_pro-title": "Pro Posters and enlargements",
    "happy_case_classic-title": "Classic Happy Case",
    "happy_case_vintage-title": "Vintage Happy Case",
    "fotokit_homedecor-title": "Home Decor PhotoKit",
    "fotokit_miniscrap-title": "Mini Scrap PhotoKit",
    "happy_case_classic-warning": "Each box must have at least {{photos}} photos. Add the remaining ones to proceed.",
    "happy_case_vintage-warning": "Each box must have at least {{photos}} photos. Add the remaining ones to proceed.",
    "fotokit_homedecor-warning": "Each PhotoKit  must have at least {{photos}} photos. Add the remaining ones to proceed.",
    "fotokit_miniscrap-warning": "Each PhotoKit  must have at least {{photos}} photos. Add the remaining ones to proceed.",
    "print_classic_with_border-title": "Bordered Prints",
    "all-products-project-description": "All products in this project"
  },
  "modal-cut-alert": {
    "title": "Some photos will be cropped",
    "description": "We recommend checking your cropping carefully before proceeding",
    "review": "Review",
    "continue": "Continue"
  },
  "badge-crop-alert": {
    "cuts-check": "Check crops"
  },
  "modal-cut-confirmation-alert": {
    "title": "Do you confirm all framing?",
    "description": "By confirming, you accept the crops that will be applied to your photos",
    "review": "Review",
    "continue": "Confirm",
    "title-confirm": "Do you confirm all crops?",
    "title-later": "Do you want to exit without saving your crops?",
    "description-confirm": "Once your order is confirmed, photos will be printed exactly as you see them.",
    "description-later": "Once your order is confirmed, photos will be printed exactly as you see them.",
    "review-confirm": "Review",
    "review-later": "Review framing",
    "continue-confirm": "Save and add to cart",
    "continue-later": "Exit without saving"
  },
  "modal-adjust-crops": {
    "title": "Framing",
    "save_and_close": "Save and continue",
    "go-back": "Go back",
    "review-later": "Exit without saving"
  },
  "help-button": {
    "privacy": "Privacy Policy",
    "tutorial": "Check tutorial",
    "open": "Open help menu"
  },
  "orientation": {
    "horizontal": "Landscape",
    "vertical": "Portrait"
  },
  "tutorial": {
    "step-1-text": "Here you can find the photos you've selected for printing",
    "step-1-cta": "Continue",
    "step-2-text": "Click on the photos to select them and personalise them as you wish",
    "step-2-cta": "Continue",
    "step-3-text": "In this menu, you'll find the tools to customise the photos you've selected",
    "step-3-cta": "I have understood",
    "group-text": "Here you can find the photos you've selected for printing",
    "group-cta": "I have understood",
    "product-text": "Click on the photos to select them and personalise them as you wish",
    "product-cta": "Continue",
    "toolbar-text": "In this menu, you'll find the tools to customise the photos you've selected",
    "toolbar-cta": "OK, got it!",
    "zoom-text": "To move the photo better, try using the zoom.",
    "zoom-cta": "OK, got it!",
    "zoom-text-mobile": "To position the photo better, zoom by spreading your fingers."
  },
  "bottom-bar": {
    "go-to-cart": "Add to cart",
    "confirm": "Confirm"
  },
  "modal-delete-all": {
    "title": "Do you want to delete the selected photos?",
    "description": "If you change your mind, you'll have to add them to the project again.",
    "description_n": "If you change your mind, you'll have to add them to the project again.",
    "review": "Cancel",
    "confirm": "Delete"
  },
  "bottom-sheet-avoid-cuts": {
    "title": "How to avoid photo cropping",
    "description": "The recommended size best suits the photos you have selected to avoid unwanted cropping.\n\nIf you prefer another size, your photos will be cropped, but you can still adjust the framing in the next steps."
  },
  "hints": {
    "border_not_available_for_product": "The border you selected is not available for this product",
    "option_does_not_support_border": "Borders are not available for the selected option"
  },
  "text-tool-option": {
    "title": "Text",
    "font": "Font",
    "style": "Style",
    "alignment": "Align",
    "color": "Text colour",
    "button": "Apply",
    "size": "Font size"
  },
  "modal-delete-from-drawer": {
    "title": "Do you really want to delete this photo?",
    "description": "If you change your mind, you'll have to add it to the project again.",
    "abort": "Cancel",
    "confirm": "Confirm"
  },
  "badge-min-products": {
    "missing-products": "Minimum amount not reached"
  },
  "modal-over-limit-products": {
    "title": "You have exceeded the limit of {{limit}} photos for your Happy Case.",
    "description": "Want to add another box or delete some photos?",
    "remove": "Delete some photos",
    "add": "Purchase another box",
    "title_happy_case_classic": "You have exceeded the limit of {{limit}} photos for your Happy Case.",
    "title_happy_case_vintage": "You have exceeded the limit of {{limit}} photos for your Happy Case.",
    "title_fotokit_homedecor": "You have exceeded the limit of {{limit}} photos for your PhotoKit.",
    "title_fotokit_miniscrap": "You have exceeded the limit of {{limit}} photos for your PhotoKit.",
    "description_happy_case_classic": "Want to add another box or delete some photos?",
    "description_happy_case_vintage": "Want to add another box or delete some photos?",
    "description_fotokit_homedecor": "Want to add another PhotoKit or delete some photos?",
    "description_fotokit_miniscrap": "Want to add another PhotoKit or delete some photos?",
    "add_happy_case_classic": "Purchase another box",
    "add_happy_case_vintage": "Purchase another box",
    "add_fotokit_homedecor": "Add another PhotoKit",
    "add_fotokit_miniscrap": "Add another PhotoKit"
  },
  "modal-min-products-alert": {
    "title": "Minimum amount of photos required",
    "description": "Please add the missing photos to complete the box.",
    "cta": "Back to editor",
    "description_happy_case_classic": "Please add the missing photos to complete the box and add it to the cart.",
    "description_happy_case_vintage": "Please add the missing photos to complete the box and add it to the cart.",
    "description_fotokit_homedecor": "Please add the missing photos to complete the Photo Kit and add it to the cart.",
    "description_fotokit_miniscrap": "Please add the missing photos to complete the PhotoKit and add it to the cart."
  },
  "upload-smartphone": {
    "title": "Select photos from your phone gallery",
    "description": "to continue creating your project on your computer",
    "cta": "Select photos",
    "uploading-title": "We're uploading your photos",
    "uploading-description": "Do not close the app, it will only take a few moments",
    "uploaded-title": "Your photos have been uploaded to your computer",
    "uploaded-description": "If you want to add more, click below. Otherwise, you can close this page.",
    "uploaded-cta": "Add more photos",
    "error-retry-title": "Upload failed",
    "error-retry-description": "Please check your internet connection and try again. If the problem persists, contact our Support team.",
    "error-fatal-title": "Something went wrong.",
    "error-fatal-description": "Return to the QR code screen, refresh the page and try again.",
    "upload-again-title": "Upload interrupted",
    "upload-again-description": "We couldn't upload all your photos.\nPlease check your internet connection and try again. If the problem persists, contact our Support team.",
    "upload-again-cta": "Back to photo selection",
    "retry": "Try again",
    "upload-corrupted-title": "Unable to upload one or more files.",
    "upload-corrupted-description-tail-counter": " and other {{counter_file}} may be corrupted or in an unsupported format.",
    "upload-corrupted-description-tail": " they may be corrupted or in an unsupported format.",
    "upload-corrupted-description-head": "The following files: ",
    "upload-corrupted-url": "Show full list",
    "upload-corrupted-cta": "Select photos"
  },
  "upload-family-friends": {
    "title": "Select and share your photos!",
    "description": "You will help keep your memories safe forever.",
    "cta": "Select photos",
    "uploading-title": "We're uploading your photos",
    "uploading-description": "Do not close the app, this will only take a moment.",
    "uploaded-title": "Upload Complete! Let them know you completed the mission!",
    "uploaded-description": "Thank you for your valuable contribution.",
    "uploaded-cta": "Add more photos",
    "redirect": "Do you want to save memories too?",
    "redirect-cta": "Discover our products",
    "error-retry-title": "Upload failed",
    "error-retry-description": "Please check your internet connection and try again. If the problem persists, contact our Support team.",
    "error-fatal-title": "Something went wrong.",
    "error-fatal-description": "Return to the QR code screen, refresh the page and try again.",
    "upload-again-title": "Upload interrupted",
    "upload-again-description": "We couldn't upload all your photos.\nPlease check your internet connection and try again. If the problem persists, contact our Support team.",
    "upload-again-cta": "Back to photo selection",
    "retry": "Try again",
    "upload-corrupted-title": "Unable to upload one or more files.",
    "upload-corrupted-description-tail-counter": " and other {{counter_file}} may be corrupted or in an unsupported format.",
    "upload-corrupted-description-tail": " they may be corrupted or in an unsupported format.",
    "upload-corrupted-description-head": "The following files: ",
    "upload-corrupted-url": "Show full list",
    "upload-corrupted-cta": "Select photos"
  },
  "modal-picker-smartphone": {
    "upload": "Upload photos from your smartphone",
    "step-1-title": "Scan the QR code",
    "step-1-description": "using your phone's camera",
    "step-2-title": "Select the photos",
    "step-2-description": "from your phone gallery",
    "step-3-title": "See a preview of your photos here",
    "step-3-description": "then click on confirm",
    "troubleshooting": "Problems with the QR code?\nCopy and paste this link into your smartphone's browser",
    "copy-cta": "Copy link",
    "connected-title": "Connection Active!",
    "connected-description": "You can now select photos from your phone gallery. You will see them here for review.",
    "copied": "Link copied!"
  },
  "modal-picker-family-friends": {
    "upload": "Upload photos from your friends and family",
    "step-1-title": "Copy and share the link with your loved ones",
    "step-1-description": "via text, WhatsApp, email...",
    "step-2-title": "Ask them to upload the photos and let you know",
    "step-2-description": "as the link will expire after a few days",
    "step-3-title": "See a preview of your photos here",
    "step-3-description": "then click on confirm",
    "copy-cta": "Copy link",
    "share-cta": "Share link",
    "share-message": "Invitation to upload photos to the project",
    "or-choice": "Or"
  },
  "modal-below-limit-products": {
    "title": "This product requires a minimum of {{limit}} photos.",
    "description": "Add the missing photos to complete the box.",
    "cta": "Add now",
    "close": "Add later",
    "description_happy_case_classic": "Add the missing photos to complete the box.",
    "description_happy_case_vintage": "Add the missing photos to complete the box.",
    "description_fotokit_homedecor": "Add the missing photos to complete the Photo Kit.",
    "description_fotokit_miniscrap": "Add the missing photos to complete the PhotoKit."
  },
  "modal-upload-error": {
    "title": "Files not loaded",
    "cta": "OK, thanks",
    "description": "It may be corrupted or in an unsupported format. Please check and try again."
  },
  "formats-content": {
    "print_classic": {
      "7x00": "Keeps the original proportions of the shot",
      "7x_PANORAMIC": "Keeps the original proportions of the shot",
      "10x10": "Square",
      "10x13": "Default smartphone format",
      "10x15": "Standard for frames and photo albums",
      "10x_PANORAMIC": "Keeps the original proportions of the shot",
      "10x00": "Keeps the original proportions of the shot",
      "12x12": "Square",
      "12x16": "Default smartphone format",
      "12x18": "Standard for frames and photo albums",
      "12x00": "Keeps the original proportions of the shot",
      "12x_PANORAMIC": "Keeps the original proportions of the shot",
      "13x13": "Square",
      "13x17": "Default smartphone format",
      "13x17.33": "Default smartphone format",
      "13x19": "Standard for frames and photo albums",
      "13x19.5": "Standard for frames and photo albums",
      "13x_PANORAMIC": "Keeps the original proportions of the shot",
      "13x00": "Keeps the original proportions of the shot",
      "15x15": "Square",
      "15x20": "Default smartphone format",
      "15x22.5": "Standard for frames and photo albums",
      "15x22": "Standard for frames and photo albums",
      "15x_PANORAMIC": "Keeps the original proportions of the shot",
      "15x00": "Keeps the original proportions of the shot"
    },
    "poster": {
      "20x20": "",
      "20x27": "",
      "20x30": "",
      "30x40": "",
      "30x45": "",
      "40x40": "",
      "40x50": "",
      "40x60": "",
      "50x50": "",
      "50x70": "",
      "50x75": ""
    },
    "print_vintage": {
      "8x10": "Small format, big emotions to cherish.",
      "12x15": "The perfect size to bring those special moments back to life.",
      "20x25": "A memory that takes up space and lights up the room."
    },
    "print_pro": {
      "10x13": "Default smartphone format",
      "10x15": "Standard for frames and photo albums",
      "12x16": "Default smartphone format",
      "12x18": "Standard for frames and photo albums",
      "13x17.33": "Default smartphone format",
      "13x17": "Default smartphone format",
      "13x19": "Standard for frames and photo albums",
      "13x19.5": "Standard for frames and photo albums",
      "15x20": "Default smartphone format",
      "15x22.5": "Standard for frames and photo albums",
      "15x22": "Standard for frames and photo albums"
    },
    "poster_pro": {
      "20x20": "",
      "18x24": "",
      "20x25": "",
      "24x24": "",
      "20x30": "",
      "24x30": "",
      "24x36": "",
      "30x30": "",
      "30x45": "",
      "30x40": "",
      "35x35": "",
      "40x40": "",
      "35x50": "",
      "30x60": "",
      "40x50": "",
      "50x50": "",
      "40x60": "",
      "50x70": "",
      "50x60": "",
      "50x75": "",
      "60x80": "",
      "70x100": ""
    },
    "happy_case_classic": {
      "one": "",
      "other": ""
    },
    "happy_case_vintage": {
      "one": "",
      "other": ""
    },
    "fotokit_homedecor": {
      "one": "",
      "other": ""
    },
    "fotokit_miniscrap": {
      "one": "",
      "other": ""
    },
    "suggested": "Perfect for avoiding cropping your photos",
    "print_classic_with_border": {
      "7x00": "Keeps the original proportions of the shot",
      "7x_PANORAMIC": "Keeps the original proportions of the shot",
      "10x10": "Square",
      "10x13": "Default smartphone format",
      "10x15": "Standard for frames and photo albums",
      "10x_PANORAMIC": "Keeps the original proportions of the shot",
      "10x00": "Keeps the original proportions of the shot",
      "12x12": "Square",
      "12x16": "Default smartphone format",
      "12x18": "Standard for frames and photo albums",
      "12x00": "Keeps the original proportions of the shot",
      "12x_PANORAMIC": "Keeps the original proportions of the shot",
      "13x13": "Square",
      "13x17": "Default smartphone format",
      "13x17.33": "Default smartphone format",
      "13x19": "Standard for frames and photo albums",
      "13x19.5": "Standard for frames and photo albums",
      "13x_PANORAMIC": "Keeps the original proportions of the shot",
      "13x00": "Keeps the original proportions of the shot",
      "15x15": "Square",
      "15x20": "Default smartphone format",
      "15x22.5": "Standard for frames and photo albums",
      "15x22": "Standard for frames and photo albums",
      "15x_PANORAMIC": "Keeps the original proportions of the shot",
      "15x00": "Keeps the original proportions of the shot"
    }
  },
  "unsupportedEnv": {
    "title": "{{env}} is not updated",
    "description": "The version of your {{env}} is not supported.\nUpdate it to the latest version to continue using the editor without problems.",
    "incognitoTitle": "Incognito mode not supported",
    "incognitoDescription": "Open the editor in a standard window to continue.\nIf you were opening a saved project, don't worry, it isn't lost:\nyou can find it by accessing the editor via standard browsing.",
    "noAvailableSpaceTitle": "Storage full",
    "noAvailableSpaceDescription": "Free up space on your device by deleting unused photos or apps, then reload the page.",
    "noAvailableSpaceCta": "Reload page"
  },
  "toast-share-photos": {
    "title": "New photos uploaded",
    "description": "Want to view them?",
    "cta-confirm": "View",
    "cta-decline": "Not now",
    "description-single": "Want to see it?"
  },
  "group-action-bar-v3": {
    "select": "Select all",
    "deselect": "Deselect all",
    "selected": " selected photo",
    "selected_plural": " selected photos",
    "delete-selected": "Delete selected",
    "duplicate-selected": "Duplicate selected",
    "add": "Add more photos",
    "box-style": "Change style",
    "box-style-hint": "Change box style",
    "delete-selected-short": "Delete",
    "duplicate-selected-short": "Duplicate",
    "add-disabled": "Uploading photos"
  },
  "modal-network": {
    "title": "No Internet Connection",
    "description": "Check your Wi-Fi connection or network settings.",
    "sub-description-head": "Your project will still be automatically saved in the section",
    "sub-description-tail": "Your projects",
    "cta": "OK, thanks",
    "sub-description": "Your project will still be automatically saved in the section"
  },
  "group-suffix": {
    "10x13": "10x13",
    "13x19.5": "13x19",
    "8x10": "8x10",
    "15x22.5": "15x22",
    "20x27": "20x27",
    "13x13": "13x13",
    "20x30": "20x30",
    "40x50": "40x50",
    "50x50": "50x50",
    "12x15": "12x15",
    "15x15": "15x15",
    "20x25": "20x25",
    "13x17.33": "13x17",
    "12x18": "12x18",
    "40x40": "40x40",
    "40x60": "40x60",
    "15x20": "15x20",
    "50x70": "50x70",
    "50x60": "50x60",
    "12x12": "12x12",
    "50x75": "50x75",
    "10x10": "10x10",
    "7x10": "7x10",
    "30x45": "30x45",
    "10x15": "10x15",
    "12x16": "12x16",
    "30x40": "30x40",
    "20x20": "20x20",
    "8x_PANORAMIC": "8x",
    "12x_PANORAMIC": "12x",
    "30x_PANORAMIC": "30x",
    "20x_PANORAMIC": "20x",
    "13x_PANORAMIC": "13x",
    "7x_PANORAMIC": "7x",
    "10x_PANORAMIC": "10x",
    "40x_PANORAMIC": "40x",
    "15x_PANORAMIC": "15x",
    "50x_PANORAMIC": "50x",
    "13x19": "13x19",
    "15x22": "15x22",
    "13x17": "13x17",
    "8x00": "8x",
    "12x00": "12x",
    "30x00": "30x",
    "20x00": "20x",
    "13x00": "13x",
    "7x00": "7x",
    "10x00": "10x",
    "40x00": "40x",
    "15x00": "15x",
    "50x00": "50x",
    "18x24": "18x24",
    "24x24": "24x24",
    "24x30": "24x30",
    "24x36": "24x36",
    "30x30": "30x30",
    "35x35": "35x35",
    "35x50": "35x50",
    "30x60": "30x60",
    "60x80": "60x80",
    "70x100": "70x100"
  },
  "modal-new-version-available": {
    "title": "New version available",
    "description": "Reload the page to continue with the latest version.\nThe project will be saved automatically in the <bold>Your projects<\/bold> section.",
    "cta": "Reload"
  },
  "zoom-image": {
    "title": "Preview",
    "go-back": "Go back",
    "photos": "{{counter}} photos"
  },
  "bottom-sheet-group-tabs": {
    "title": ""
  },
  "modal-max-products-alert": {
    "title": "Maximum number of photos reached",
    "description": "Please remove the extra photos to continue.",
    "cta": "Back to editor",
    "description_happy_case_classic": "Please remove the extra photos to complete your box and add it to cart.",
    "description_happy_case_vintage": "Please remove the extra photos to complete your box and add it to cart.",
    "description_fotokit_homedecor": "Please remove the extra photos to complete your PhotoKit.",
    "description_fotokit_miniscrap": "Please remove the extra photos to complete your PhotoKit and add it to cart."
  },
  "modal-no-available-space": {
    "title": "Storage full",
    "description": "Free up space on your device by deleting unused photos or apps, then reload the page.",
    "cta": "Reload page"
  },
  "modal-product-not-available": {
    "title": "Product not available",
    "description-saved": "Your changes have been saved. You'll be able to add the project to your cart as soon as the product is available again.",
    "description-guest": "Your changes have been saved: log in to find the project on the “Your projects” page. You'll be able to add it to your cart as soon as the product is available again.",
    "continue-editing": "Keep editing",
    "back-to-projects": "Back to projects",
    "login": "Log in"
  }
}